import { useDispatch } from "react-redux";
import { useApolloClient } from '@apollo/client'

import * as reducers from '../../../../redux/reducers/BPMReducer';
import * as bpmSelectors from '../../../../redux/selectors';

function CreateTableObject(tableCreator) {
    const client = useApolloClient()
    const dispatch = useDispatch()

    let filters = {...tableCreator.initialFilters};

    if (tableCreator.initialSortFieldName) {
        filters['orderField'] = (tableCreator.initialSortFieldDirection == 'asc' ? "": "-") + tableCreator.initialSortFieldName;
    }

    const tableSteate = {
        count: 0,
        tableName: tableCreator.tableName,
        filters: {
            filters: filters,
            orderField: tableCreator.initialSortFieldName,
            orderDirection: tableCreator.initialSortFieldDirection
        },
        selectAllState: {
            selectAll: false, 
            selectedRows: [], 
            selectedRefs: []
        }
    }
    dispatch(reducers.addBPMTable(tableSteate))

    const tableStatesSelector = bpmSelectors.useTableStates(tableCreator.tableName)
    const tableCountSelector = bpmSelectors.useTableCount(tableCreator.tableName)
    const tableFiltersSelector = bpmSelectors.useTableFilters(tableCreator.tableName)
    const tableOrderFieldSelector = bpmSelectors.useTableOrderField(tableCreator.tableName)
    const tableOrderDirectionSelector = bpmSelectors.useTableOrderDirection(tableCreator.tableName)
    const tableSlectAllStateSelector = bpmSelectors.useTableSelectAllState(tableCreator.tableName)
    const tableSelectedRowsSelector = bpmSelectors.useTableSelectedRows(tableCreator.tableName)
    const tableSelectedRefsSelector = bpmSelectors.useTableSelectedRefs(tableCreator.tableName)
    const tableColumnsSelector = bpmSelectors.useTableColumns(tableCreator.tableName)

    const currentUserSelector = bpmSelectors.useCurrentUser()
    const currentCompanySelector = bpmSelectors.useCurrentCompany()
    const currentUserMembershipSetSelector = bpmSelectors.useCurrentUserMembershipSet()

    const selectors = {
        'tableStatesSelector': tableStatesSelector,
        'tableCountSelector': tableCountSelector,
        'tableFiltersSelector': tableFiltersSelector, 
        'tableOrderFieldSelector': tableOrderFieldSelector,
        'tableOrderDirectionSelector': tableOrderDirectionSelector,
        'tableSlectAllStateSelector': tableSlectAllStateSelector,
        'tableSelectedRowsSelector': tableSelectedRowsSelector,
        'tableSelectedRefsSelector': tableSelectedRefsSelector,
        'tableColumnsSelector': tableColumnsSelector,
        'currentUserSelector': currentUserSelector,
        'currentCompanySelector': currentCompanySelector,
        'currentUserMembershipSetSelector': currentUserMembershipSetSelector,
    }

    return tableCreator.create(
        client,
        dispatch,
        reducers,
        selectors
    )
}

export default CreateTableObject
